import { Drawer, Spin } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { Map, TileLayer, Marker } from 'react-leaflet';
import { Icon } from 'leaflet'
import { useTemplate } from "../../../utils/Template";
import { tt_name_block_warning } from "../../../utils/Utils";
import marker from "../../../media/marker.png"

export default function MapStoresLocation(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);

    const [load, setLoad] = useState(false);

    useEffect(() => {

        setTimeout(() => {
            setLoad(true);
        }, 500)

    }, [load])

    const icon = new Icon({
        iconUrl: marker,
        iconSize: [60, 60], // size of the icon
        iconAnchor: [30, 45], // point of the icon which will correspond to marker's location
        popupAnchor: [0, -76] // point from which the popup should open relative to the iconAnchor

    })

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        container = false,
        data = {},
        date_changed = 0,
        injected_data = []
    } = content;

    // Component specific
    const {
        name = "Contact & Hours Map",
    } = data;

     // Defaults (kelowna)
     let latitude = 49.88609;
     let longitude = -119.4941869;
 
     // Single store
     if (injected_data.length === 1) {
         latitude = injected_data[0].lat;
         longitude = injected_data[0].lng;
     }
 
     // Multistore
     if (injected_data.length > 1) {
         let _loc = window.store_id; 
         let _index = window.sitesettings.stores.findIndex(item => item.id === _loc);
         if (_index < 0) { _index = 0; }
         latitude = injected_data[_index].lat;
         longitude = injected_data[_index].lng;
     }


    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    if(!load){
        return(<Spin spinning={!load}>
       <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={{ "height": "400px", "marginBottom": "-20px", "position": "relative", "overflow" : "hidden"}}>
                   
                </div>
            </div>
        </Spin>);
    }

    const drawRender = () => {


        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={{ "height": "400px", "marginBottom": "-20px", "position": "relative", "overflow" : "hidden"}}>
                    <Map scrollWheelZoom={false} style={{ "height": "380px", "overflow" : "hidden" }} center={{ lat: latitude, lng: longitude }} zoom={14}>
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
                        <Marker  icon={icon} key={"marker"} position={[latitude, longitude]} />
                    </Map>
                </div>
            </div>
        )

    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading hide_date hide_container menus={props.menus} trash={trash} close={close} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}